import { useState, useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import SntCloseSmallIcon from "@icons/SntCloseSmallIcon";
import SntSearchIcon from "@icons/SntSearchIcon";

interface SntSearchProps {
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (text: string) => void;
  title?: string;
  className?: string;
}

const SntSearch = ({
  value = "",
  placeholder = "",
  disabled = false,
  onChange,
  title = "",
  className = "",
}: SntSearchProps) => {
  const [keyUpDelay, setKeyUpDelay] = useState<NodeJS.Timeout | null>(null);
  const [searchText, setSearchText] = useState(value);

  useEffect(() => {
    setSearchText(value);
  }, [value]);

  const onChangeInput = (text: string) => {
    setSearchText(text);
    // Key up delay 500ms
    if (keyUpDelay) clearTimeout(keyUpDelay);

    setKeyUpDelay(
      setTimeout(() => {
        onChange?.(text);
      }, 500)
    );
  };

  return (
    <InputGroup style={{ width: 300 }} className={className}>
      <Form.Control
        style={searchText ? { borderRight: "white" } : { borderRight: "" }}
        value={searchText}
        placeholder={placeholder}
        title={title}
        disabled={disabled}
        onChange={(e) => onChangeInput(e.target.value)}
      />
      {searchText && !disabled && (
        <InputGroup.Text
          style={{ background: "none" }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setSearchText("");
            onChange?.("");
          }}
        >
          <SntCloseSmallIcon />
        </InputGroup.Text>
      )}
      <InputGroup.Text
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setSearchText(searchText);
          onChange?.(searchText);
        }}
      >
        <SntSearchIcon />
      </InputGroup.Text>
    </InputGroup>
  );
};

export default SntSearch;
